import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8.74 11.2h-2.1a.75.75 0 0 1 0-1.5h2.1a.75.75 0 0 1 0 1.5Zm2.84-3.14a.75.75 0 0 0-.75-.75H6.64a.75.75 0 0 0 0 1.5h4.19a.74.74 0 0 0 .75-.75Zm-.52-2.39a.75.75 0 0 0-.75-.75H6.64a.75.75 0 1 0 0 1.5h3.67a.76.76 0 0 0 .75-.75Zm3.83.39v4a3.76 3.76 0 0 1-3.75 3.75H4.89a3.75 3.75 0 0 1-3.75-3.69V3.36c0-1.6 1.15-2.14 2.89-2.14v1.2a3.66 3.66 0 0 1 .88-.11h6.25a3.76 3.76 0 0 1 3.73 3.75Zm-1.5 0a2.25 2.25 0 0 0-2.25-2.25H4.89A2.16 2.16 0 0 0 4 4v5h-.3a1.08 1.08 0 0 0-1.07.69v.41a2.25 2.25 0 0 0 2.25 2.25h6.25a2.25 2.25 0 0 0 2.25-2.25Zm-1.67-3.77';
const draw24px =
  'M18.25,4.55H5.93v-2c-2.26,0-4,.82-4,3.25V8.11a1.21,1.21,0,0,0,0,.19v9.17a3.76,3.76,0,0,0,3.75,3.75H18.25A3.75,3.75,0,0,0,22,17.47V8.3A3.75,3.75,0,0,0,18.25,4.55ZM20.5,17.47a2.25,2.25,0,0,1-2.25,2.25H5.67a2.25,2.25,0,0,1-2.25-2.25v-.21h0a1.65,1.65,0,0,1,1.75-1.75h.75V6.05H18.25A2.25,2.25,0,0,1,20.5,8.3ZM13.32,17H10a.75.75,0,0,1,0-1.5h3.32a.75.75,0,0,1,0,1.5Zm3.33-3.32H10a.75.75,0,0,1,0-1.5h6.65a.75.75,0,0,1,0,1.5Zm-.83-3.32H10a.75.75,0,0,1,0-1.5h5.82a.75.75,0,0,1,0,1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const SheetsLogIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'sheetsLog'),
) as IconWithRender;

SheetsLogIcon.displayName = 'SheetsLogIcon';
SheetsLogIcon.propTypes = Icon.propTypes;
SheetsLogIcon.renderIcon = (props) => <SheetsLogIcon {...props} />;
export default SheetsLogIcon;
